import type { JSX } from 'react'

import { InlinePrimaryLoginTemplate } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"
import { TextBoxCaption3, TextBoxCaption3Secondary } from "/app/libraries/arcana/src/atoms/TextBox/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import { exists } from '~/shared/helpers'
import {
  $locked,
  $permError,
  resendNewResetPasswordCode,
  verifyResetPasswordCodeFx,
} from '../model'

VerifyTextBlock.displayName = 'VerifyTextBlock'
export function VerifyTextBlock({
  liveTo,
  liveResendIn,
}: {
  liveTo?: string | null
  liveResendIn?: string | null
}): JSX.Element {
  const { t } = useTranslation()

  const locked = useUnit($locked)
  const permanentError = useUnit($permError)
  const pending = useUnit(verifyResetPasswordCodeFx.pending)

  if (locked) {
    return <TextBoxCaption3 title={t('confirmation_success')} />
  }

  if (liveTo === null) {
    return <TextBoxCaption3 title={t('reset_password_request_expired_error')} />
  }

  if (exists(permanentError)) {
    return <TextBoxCaption3 title={t(permanentError)} />
  }

  if (exists(liveResendIn)) {
    return (
      <TextBoxCaption3Secondary
        title={t('code_request_new_timer_web', {
          time: liveResendIn,
        })}
      />
    )
  }

  return (
    <InlinePrimaryLoginTemplate
      title={t('code_request_new')}
      disabled={pending || locked}
      onClick={() => resendNewResetPasswordCode()}
    />
  )
}
